<template>
  <div id="collect-form-page">
    <!-- 表单 - start -->
    <CollectForm
      v-if="formDefination4Component"
      :key="collectFormComponentKey"
      :formDefinition="formDefination4Component"
      :readonly="readonly"
      :submitTime="submitTime"
      @submit="submit"
    ></CollectForm>
    <!-- 表单 - end -->

    <!-- 提交时间 - start -->
    <div v-if="readonly && submitTime" class="collect-form-submit-time">于{{ submitTime }}完成提交</div>
    <!-- 提交时间 - end-->

    <!-- 历史记录按钮 - start -->
    <div v-if="!readonly && submitCount && submitCount > 0" class="link" @click="gotoHistory">查看历史提交记录 ({{ submitCount }})</div>
    <!-- 历史记录按钮 - end-->

    <!-- 更改数据按钮 - start -->
    <div
      class="edit-btn-wrapper"
      v-if="formDef && formDef.modifiable == 'last_submit' && formDef.status === '1' && isLastRecord && inTimeLimit && $route.query.self"
    >
      <van-button v-if="readonly" native-type="button" type="primary" icon="edit" class="edit-btn" @click="gotoEdit">更改数据</van-button>
      <van-button v-if="!readonly" native-type="button" type="danger" icon="close" class="cancel-edit-btn" @click="cancelEdit">取消更改</van-button>
    </div>
    <!-- 更改数据按钮 - end-->

    <!-- 页脚 - start -->
    <div v-if="formDef && formDef.footerText" class="collect-form-footer">{{formDef.footerText}}</div>
    <!-- 页脚 - end -->
  </div>
</template>

<script>
import CollectForm from "./CollectForm";
import request from "@/utils/RequestWithVant";
import deepClone from "@/utils/DeepClone";
import uuid from "@/utils/UUID";
import moment from "moment";
import { oldSubmitFillNewDef } from "@/utils/FormUtils.js";

export default {
  components: { CollectForm },
  props: ["id"],
  data() {
    return {
      collectFormComponentKey: 0, // 用于重新渲染（key变更会导致页面重新渲染）
      formDefination4Component: null, // 传给组件的表单定义
      formDef: null, // 表单定义
      formReview: null, // 表单回看
      readonly: false,
      submitTime: null, // 提交时间（回看时用到）
      submitCount: null, // 提交次数
      isLastRecord: false, // 是最后一条数据
      inTimeLimit: false, // 在时间限制范围内
      submitId: null, // 当前提交记录的ID（编辑时使用）
    };
  },
  computed: {},
  created() {
    let _that = this;
    if (this.id) {
      if (this.$route.query.mode == "preview") {
        // 预览表单
        let _that = this;
        new Promise(function (resolve) {
          _that.getFormDef(resolve);
        }).then(function () {
          _that.formDefination4Component = deepClone(_that.formDef);
        });
      } else if (this.$route.query.mode == "review") {
        // 回看提交记录
        this.readonly = true;
        this.submitId = this.$route.query.sid;
        this.getSubmitHistory();
        this.getLastSubmit();
        this.getFormDef();
      } else if (this.$route.query.mode == "mgrEdit") {
        // 管理员编辑
        this.submitId = this.$route.query.sid;
        new Promise(function (resolve) {
          _that.getFormDef(resolve);
        }).then(function () {
          new Promise(function (resolveTwo) {
            _that.getSubmitHistory(resolveTwo);
          }).then(function () {
            let mixedForm = oldSubmitFillNewDef(
              deepClone(_that.formDef),
              _that.formReview
            );
            _that.formDefination4Component = Object.assign({}, mixedForm);
            _that.readonly = false;
          });
        });
      } else {
        // 正常填写表单
        request
          .showLoading()
          .get(
            "./api/collect/submitCheck/" +
              this.id +
              "?clientId=" +
              this.getClientId()
          )
          .then((res) => {
            if (res.data) {
              delete res.data.data;
              localStorage.setItem("idata_info", JSON.stringify(res.data));
              this.$router.replace({
                path: "/info/" + this.id,
              });
            } else {
              // 获取表单定义
              new Promise(function (resolve) {
                _that.getFormDef(resolve);
              }).then(function () {
                _that.formDefination4Component = deepClone(_that.formDef);
              });
              // 获取当前用户已提交次数
              this.getSubmitCount();
            }
          });
      }
    }
  },
  methods: {
    getFormDef: function (resolve) {
      request
        .showLoading()
        .get("./api/form/definition/get/" + this.id)
        .then((res) => {
          try {
            let obj = JSON.parse(res.data.defJson);
            // 初始化题目数据 - start
            for (let i = 0; i < obj.itemList.length; i++) {
              let item = obj.itemList[i];
              item.index = i; // 序号
              item.display = false; // 显示状态
            }
            // 初始化题目数据 - end
            this.formDef = obj;
            for (var key in res.data) {
              this.formDef[key] = res.data[key];
            }
            document.title = this.formDef.subject;

            // 检查时间限制
            if (this.formDef.timeLimit == "unlimited") {
              this.inTimeLimit = true;
            } else if (this.formDef.timeLimit == "limited") {
              if (
                this.formDef.startTime &&
                new Date() < moment(this.formDef.startTime).toDate()
              ) {
                this.inTimeLimit = false;
              } else if (
                this.formDef.endTime &&
                new Date() > moment(this.formDef.endTime).toDate()
              ) {
                this.inTimeLimit = false;
              } else {
                this.inTimeLimit = true;
              }
            }
          } catch (err) {
            console.error(err);
          }

          if (resolve && typeof resolve == "function") {
            resolve();
          }
        });
    },
    submit: function () {
      if (this.formDef.status === "1" && this.$route.query.mode != "preview") {
        let formData = deepClone(this.formDefination4Component);
        let formId = this.id;
        let clientId = this.getClientId();
        let originalData = JSON.stringify(formData);
        let itemList = formData.itemList;
        for (var i = 0; i < itemList.length; i++) {
          let item = itemList[i];
          if (item.type === "checkbox") {
            if ("value" in item) {
              item.value = item.value.join(",");
            }
          }
        }
        let url = "./api/collect/submit";
        if (this.submitId && this.$route.query.mode == "review") {
          url = "./api/collect/modify";
        } else if (this.submitId && this.$route.query.mode == "mgrEdit") {
          url = "./api/collect/mgrEdit";
        }

        this.$dialog
          .confirm({
            message: "确认要提交吗？",
          })
          .then(() => {
            request
              .showLoading("提交中..")
              .post(url, {
                formId,
                clientId,
                itemList,
                originalData,
                submitId: this.submitId,
              })
              .then((res) => {
                localStorage.setItem("idata_info", JSON.stringify(res.data));
                this.$router.replace({
                  path:
                    "/info/" +
                    formId +
                    "?mode=" +
                    (this.$route.query.mode || ""),
                });
              });
          })
          .catch(() => {});
      } else {
        this.$toast("预览模式不能提交数据");
      }
    },
    getLabelFromOptions: function (options, value) {
      for (var i = 0; i < options.length; i++) {
        let option = options[i];
        if (option.value === value) {
          return option.label;
        }
      }
    },
    getClientId() {
      let clientId = localStorage.getItem("idata_client_id");
      if (!clientId) {
        clientId = uuid();
        localStorage.setItem("idata_client_id", clientId);
      }
      return clientId;
    },
    getSubmitHistory: function (resolve) {
      request
        .showLoading()
        .get("./api/collect/getSubmitHistory/" + this.id + "/" + this.submitId)
        .then((res) => {
          try {
            let obj = JSON.parse(res.data.original_data);
            this.formReview = obj;
            this.submitTime = res.data.submit_time;
            document.title = this.formReview.subject;

            this.formDefination4Component = deepClone(this.formReview);
          } catch (err) {
            console.error(err);
          }

          if (resolve && typeof resolve == "function") {
            resolve();
          }
        });
    },
    getSubmitCount() {
      request
        .get(
          "./api/collect/getSubmitCount/" +
            this.id +
            "?clientId=" +
            this.getClientId()
        )
        .then((res) => {
          this.submitCount = res.data;
        });
    },
    gotoHistory() {
      this.$router.push({
        path: "/history/" + this.id,
      });
    },
    gotoEdit() {
      let mixedForm = oldSubmitFillNewDef(
        deepClone(this.formDef),
        this.formReview
      );
      this.formDefination4Component = Object.assign({}, mixedForm);
      this.readonly = false;
      this.collectFormComponentKey += 1;
      setTimeout(() => {
        document.getElementById("collect-form-page").scrollIntoView({
          behavior: "smooth",
        });
      }, 100);
    },
    cancelEdit() {
      this.formDefination4Component = Object.assign({}, this.formReview);
      this.readonly = true;
      this.collectFormComponentKey += 1;
    },
    getLastSubmit() {
      request
        .get(
          "./api/collect/getLastSubmit/" +
            this.id +
            "?clientId=" +
            this.getClientId()
        )
        .then((res) => {
          if (res.data) {
            let lastSubmit = res.data;
            if (lastSubmit.id == this.submitId) {
              this.isLastRecord = true;
            }
          }
        });
    },
  },
};
</script>

<style scoped>
@import url(./CollectForm.css);

.link {
  text-align: center;
  color: #969799;
  text-decoration: underline;
  cursor: pointer;
  padding-bottom: 15px;
}
.edit-btn {
  background: linear-gradient(353deg, #4592fb, #1e79f4) !important;
  height: auto;
  padding: 5px 10px !important;
  border-radius: 15px !important;
  box-shadow: 0 4px 8px 0 rgb(77 128 240 / 25%) !important;
  border: none !important;
  margin-bottom: 15px;
}
.cancel-edit-btn {
  color: #969799;
  background: none !important;
  height: auto;
  border-radius: 15px !important;
  border: none !important;
  margin-bottom: 15px;
}
.edit-btn-wrapper {
  text-align: center;
}
</style>